import React, { useState, useEffect } from "react";
import { Grid, Card, Tabs, Tab, Box, TextField, Button, Backdrop, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { url, fileUploadUrl } from "../../constant";

function BandihubFeatureDashboard() {
  const [tab, setTab] = useState(0);
  const [heading, setHeading] = useState("");
  const [features, setFeatures] = useState([]);

  const [formState, setFormState] = useState({ title: "", description: "" });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  
  useEffect(() => {
    fetchHeading();
    fetchFeatures();
  }, []);

  // Heading fetch karne ke liye
  const fetchHeading = () => {
    fetch(`${url}auth/bandihub-heading`)  // backend ka endpoint
      .then((res) => res.json())
      .then((data) => {
        setHeading(data.data || "Default Heading");
      })
      .catch((err) => console.error("Failed to fetch heading:", err));
  };

  // Features fetch karne ke liye (same as before)
  const fetchFeatures = () => {
    setLoading(true);
    fetch(`${url}auth/get-bandihub-features`)
      .then((res) => res.json())
      .then((data) => {
        setFeatures(data.data || []);
      })
      .catch((err) => console.error("Failed to fetch features:", err))
      .finally(() => setLoading(false));
  };


  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Descrizione", accessor: "description" },
    {
      Header: "Azioni",
      accessor: "actions",
      Cell: ({ row }) => (
        <>

        <Button
          variant="contained"
          size="small"
          sx={{ backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}

          onClick={() => {
            setFormState({
              title: "",
              description: row.original.description,
            });

            setEditId(row.original.id);
            setTab(1);
          }}
        >
          Modifica
        </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDelete(row.original.id)}
            sx={{
              fontWeight: 'bold',
              padding: '8px 16px',
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' },
              marginLeft: 2
            }}
          >
            Cancella
          </Button>

        </>
      )
    }
  ];


  const rows = features.map((f) => ({ ...f, actions: "" }));


  // const handleSave = () => {
  //   setFormLoading(true);

  //   const method = editId ? "POST" : "POST";
  //   const endpoint = editId
  //     ? `${url}auth/update-bandihub-feature/${editId}/` // Replace with your real update route
  //     : `${url}/bandihub-features`;         // Replace with your real create route

  //   const payload = {
  //     title: formState.title,
  //     description: formState.description,
  //   };

  //   fetch(endpoint, {
  //     method: method,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //     body: JSON.stringify(payload),
  //   })
  //     .then((res) => res.json())
  //     .then(() => {
  //       fetchFeatures(); // Refresh list after save
  //       setFormState({ title: "", description: "" });
  //       setEditId(null);
  //       setTab(0);
  //     })
  //     .catch((err) => {
  //       console.error("Save failed:", err);
  //     })
  //     .finally(() => {
  //       setFormLoading(false);
  //     });
  // };


  const handleSave = () => {
    setLoading(true);

    const featureEndpoint = editId
      ? `${url}auth/update-bandihub-feature/${editId}`
      : `${url}auth/create-bandihub-feature`;

    const headingEndpoint = `${url}auth/bandihub-heading`;

    const featurePayload = {
      title: heading, // Assign heading to title
      description: formState.description,
    };

    const headingPayload = {
      title: heading,
    };

    // Step 1: Update the heading first
    fetch(headingEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(headingPayload),
    })
      .then((res) => res.json())
      .then(() => {
        // Step 2: Then update/create the feature

        if (featurePayload.description && featurePayload.description.trim() !== "") {
          return fetch(featureEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(featurePayload),
          });
        }else{
          // Return a resolved promise with dummy response to keep chain consistent
          return Promise.resolve(null);
        }

      })
      .then((res) => {
        if (res) {
          // If fetch was done, parse JSON
          return res.json();
        }
        // If no fetch, return null or empty object to continue chain
        return null;
      })
      .then(() => {
        fetchFeatures();
        fetchHeading();
        setFormState({ title: "", description: "" });
        setEditId(null);
        setTab(0);
      })
      .catch((err) => {
        console.error("Save failed:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa feature?")) return;

    setLoading(true);
    fetch(`${url}auth/delete-bandihub-feature/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete");
        return res.json();
      })
      .then(() => {
        fetchFeatures(); // refresh list after deletion
      })
      .catch((err) => {
        console.error("Delete failed:", err);
      })
      .finally(() => setLoading(false));
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient"
                bgColor="#183759" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  BandiHub Features
                </MDTypography>
              </MDBox>

              <Tabs value={tab} onChange={(e, val) => setTab(val)} variant="fullWidth">
                <Tab label="Elenco Features" />
                <Tab label={editId ? "Modifica Feature" : "Nuova Feature"} />
              </Tabs>

              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10 }}
                    showTotalEntries={false}
                    noEndBorder
                    currentPageIndex={currentPageIndex}
                    setCurrentPageIndex={setCurrentPageIndex}
                  />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      
                      <TextField
                        label="Sezione Heading"
                        fullWidth
                        value={heading}
                        onChange={(e) => setHeading(e.target.value)}
                        sx={{ mb: 3 }}
                      />

                      <TextField
                        label="Descrizione"
                        fullWidth
                        multiline
                        rows={3}
                        value={formState.description}
                        onChange={(e) =>
                          setFormState({ ...formState, description: e.target.value })
                        }
                        sx={{ mb: 2 }}
                      />
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        sx={{ mb: 5, backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}
                      >
                        {editId ? "Aggiorna" : "Salva"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default BandihubFeatureDashboard;
